import { buildCommunityTemplateRows } from "@utils/communityTemplateRows";
export const buildCommunityViewModels = ({ templates, subjects, reports, }) => {
    var _a;
    if (!templates.length)
        return [];
    const subjectMap = new Map(subjects.map((s) => [s._id, s]));
    const reportMap = new Map(reports.filter((r) => r === null || r === void 0 ? void 0 : r.overview).map((r) => [r.overview.subjectId, r]));
    const grouped = new Map();
    for (const template of templates) {
        const existing = (_a = grouped.get(template.subjectId)) !== null && _a !== void 0 ? _a : [];
        existing.push(template);
        grouped.set(template.subjectId, existing);
    }
    return Array.from(grouped.entries()).map(([subjectId, subjectTemplates]) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const subject = subjectMap.get(subjectId);
        const reportData = reportMap.get(subjectId);
        const subjectName = (_c = (_a = subject === null || subject === void 0 ? void 0 : subject.name) !== null && _a !== void 0 ? _a : (_b = reportData === null || reportData === void 0 ? void 0 : reportData.overview) === null || _b === void 0 ? void 0 : _b.subjectName) !== null && _c !== void 0 ? _c : "Unknown Community";
        return {
            subjectId,
            subjectName,
            subjectAddress: (_f = (_d = subject === null || subject === void 0 ? void 0 : subject.address) !== null && _d !== void 0 ? _d : (_e = reportData === null || reportData === void 0 ? void 0 : reportData.overview) === null || _e === void 0 ? void 0 : _e.subjectAddress) !== null && _f !== void 0 ? _f : "",
            autoReportEnabled: (_g = subject === null || subject === void 0 ? void 0 : subject.autoReportEnabled) !== null && _g !== void 0 ? _g : false,
            templates: buildCommunityTemplateRows({
                templates: subjectTemplates,
                reports: reportData === null || reportData === void 0 ? void 0 : reportData.reports,
                subjectId,
                subjectName,
                fallbackLatestReportDate: (_j = (_h = reportData === null || reportData === void 0 ? void 0 : reportData.overview) === null || _h === void 0 ? void 0 : _h.createdOn) !== null && _j !== void 0 ? _j : null,
            }),
        };
    });
};
